var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"global_wrapper landing\"><navbar></navbar><div id=\"preloader2\" ng-if=\"show_spinner\"><img" + (jade.attr("src", require('./../../images/6.gif'), true, true)) + " width=\"114\" alt=\"\"><p>Loading...</p></div><div ui-view=\"\" ng-if=\"!show_spinner\"></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/home.jade
// module id = 557
// module chunks = 0